/* @flow */

export const requestStarted = (request: Object) => (dispatch: Dispatch) => {
  dispatch({ type: 'NETWORK_REQUEST_STARTED', payload: request });

  return request;
};

export const requestEnded = (response: Object) => (dispatch: Dispatch) => {
  dispatch({ type: 'NETWORK_REQUEST_ENDED', payload: response });

  return response;
};
